var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Adult"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2947 5.98195C14.7389 5.98195 15.9097 4.81118 15.9097 3.36695C15.9097 1.92273 14.7389 0.751953 13.2947 0.751953C11.8505 0.751953 10.6797 1.92273 10.6797 3.36695C10.6797 4.81118 11.8505 5.98195 13.2947 5.98195Z",
    fill: "#0C71C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9868 6.73514H11.6018C9.8118 6.66264 8.2993 8.05014 8.2168 9.84014V14.2826C8.2443 15.3101 8.9243 16.2076 9.9093 16.5076V22.5651C9.8518 23.5651 10.6043 24.4251 11.6018 24.5026H14.9868C15.9843 24.4251 16.7368 23.5651 16.6793 22.5651V16.5076C17.6618 16.2051 18.3443 15.3101 18.3718 14.2826V9.84014C18.2893 8.05014 16.7768 6.66264 14.9868 6.73514Z",
    fill: "#0C71C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdult);
export default __webpack_public_path__ + "static/media/Adult.c06e3625eaa3fdf2679ea6f90f0f58d4.svg";
export { ForwardRef as ReactComponent };